import { Link } from "react-router-dom";

import {
  ALLI_AI_BRAND_NAME,
  ALLI_TERMS_OF_SERVICE_URL,
} from "~/helpers/consts";
import { isWhiteLabel } from "~/utils/white-label";

import styles from "./TermsOfServiceNotice.module.scss";

const TermsOfServiceNotice = () => (
  <div className={styles.terms}>
    By submitting this form, you agree to{" "}
    {isWhiteLabel() ? "our" : `all ${ALLI_AI_BRAND_NAME}'s`}{" "}
    <Link className={styles.link} to={ALLI_TERMS_OF_SERVICE_URL}>
      Terms of Service
    </Link>
  </div>
);

export default TermsOfServiceNotice;
